module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Undefined":"Nicht definiert","Download file":"Datei herunterladen","No file":"Keine Datei","File":"Datei"}}')
  delete Component.options._Ctor
}
